<template>
    <div class="card-square card-component relative" @click="handleClick" :class="{ active: isSelected }">
        <div class="absolute gradient-bg"></div>
        <div class="checkbox absolute flex items-center justify-center">
            <img src="/img/done-green-18dp.svg" v-show="isSelected">
        </div>
        <div class="icon-container">
            <i class="icon-cinergia" :class=[icon]></i>
        </div>
        <p class="flex items-center text-center">
            {{title}}
        </p>
    </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import {GETTERS, MUTATIONS} from '../../../store/wizard/types';

export default {
    props:{
        title: String,
        icon: String,
        id: Number
    },
    computed: {
        ...mapGetters({
            consult: GETTERS.GET_CONSULT
        }),
        isSelected(){
            return this.consult.applications.includes(this.id);
        }
    },
    methods: {
        ...mapMutations({
            toggleApplication: MUTATIONS.TOGGLE_CONSULT_APPLICATION
        }),
        handleClick(){
            this.toggleApplication(this.id);
        },
    }
}
</script>
